/** Crisp segment for SafeGeo embedded admin (mirrors pickads-fe crisp-session). */
export const CRISP_SEGMENT_SAFEGEO_ADMIN = "safegeo_admin";

export type CrispVisitorContext = {
  shop?: string | null;
  plan?: string | null;
  appId?: string | null;
  appHandle: string;
  email?: string | null;
  name?: string | null;
  userId?: string | null;
  pageUrl?: string;
  pagePath?: string;
  screen?: string;
};

/** Session custom data for agents in the Crisp inbox. */
export function buildCrispVisitorSessionData(
  context: CrispVisitorContext,
): Record<string, string> {
  return {
    product: "safegeo",
    app_id: (context.appId || "").trim(),
    app_handle: context.appHandle.trim(),
    shop: (context.shop || "").trim(),
    plan: (context.plan || "unknown").trim(),
    email: (context.email || "").trim(),
    user_id: (context.userId || "").trim(),
    page_url: (context.pageUrl || "").trim(),
    page_path: (context.pagePath || "").trim(),
    screen: (context.screen || "").trim(),
  };
}

export function crispSessionRows(
  context: CrispVisitorContext,
): [string, string][] {
  return Object.entries(buildCrispVisitorSessionData(context)).filter(
    ([, v]) => v.length > 0,
  ) as [string, string][];
}

/** Best-effort staff user id from App Bridge session token (`sub`). */
export async function readShopifyStaffSub(): Promise<string | null> {
  try {
    const token = await window.shopify?.idToken?.();
    if (!token) return null;
    const part = token.split(".")[1];
    if (!part) return null;
    const json = JSON.parse(
      atob(part.replace(/-/g, "+").replace(/_/g, "/")),
    ) as { sub?: string };
    const sub = String(json.sub || "").trim();
    return sub || null;
  } catch {
    return null;
  }
}
